// extracted by mini-css-extract-plugin
export default {"slider-container":"min-max-slider_slider-container__BND4J","min-max-btn":"min-max-slider_min-max-btn__S2Uhf","slider":"min-max-slider_slider__xvQgE"};